"use strict";

import angular from "angular";

import template from "./chart-skeleton.component.html";
import "./chart-skeleton.component.scss";

class ChartSkeletonComponent {
    constructor() {}

    $onInit() {}
}

ChartSkeletonComponent.$inject = [];

const component = {
    bindings: {
        type: "@"
    },
    controller: ChartSkeletonComponent
};

const name = "chartSkeletonComponent";
const def = {
    ...component,
    template
};
angular.module("nucont.shared").component(name, def);
export default { name, ...def };
